export enum TaxType {
  CustomPercentage = 'custom-percentage',
  Exempt = 'exempt',
  SalesTax = 'sales-tax',
  Standard = 'standard',
  ValueAddedTax = 'value-added-tax',
}
